import { Spinner } from "./Shared";

// Small shared states for pages: loading, error, empty.

export function Loading({ label = "Loading…" }) {
  return (
    <p role="status" style={{ display: "flex", alignItems: "center", gap: 8, color: "#6b7280", fontSize: 14 }}>
      <Spinner /> {label}
    </p>
  );
}

export function ErrorNote({ error }) {
  if (!error) return null;
  return (
    <div role="alert" style={{ padding: "10px 14px", borderRadius: 8, background: "rgba(220,38,38,0.06)", border: "1px solid rgba(220,38,38,0.25)", color: "#b91c1c", fontSize: 13, margin: "0 0 14px" }}>
      {error.message || String(error)}
    </div>
  );
}

export function Empty({ children }) {
  return <p style={{ color: "#6b7280", fontSize: 14, margin: "8px 0" }}>{children}</p>;
}

export function SectionTitle({ children, right }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, margin: "0 0 14px" }}>
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{children}</h2>
      {right}
    </div>
  );
}

export function formatBytes(n) {
  if (n == null) return "";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i += 1; }
  return `${i === 0 ? v : v.toFixed(1)} ${units[i]}`;
}
